"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var a=a=>({root:{color:({color:b})=>b?a.palette.common[b]:a.palette.common.gray600}});exports.default=a
//# sourceMappingURL=styles.js.map
